window.jwConfirmRemove = function (callback) {

    const modal =
        document.getElementById('jw-remove-modal');

    modal.classList.add('active');

    const confirmBtn =
        document.getElementById('jw-remove-confirm');

    const cancelBtn =
        document.getElementById('jw-remove-cancel');

    const newConfirm =
        confirmBtn.cloneNode(true);

    const newCancel =
        cancelBtn.cloneNode(true);

    confirmBtn.parentNode.replaceChild(
        newConfirm,
        confirmBtn
    );

    cancelBtn.parentNode.replaceChild(
        newCancel,
        cancelBtn
    );

    newConfirm.addEventListener('click', () => {

        modal.classList.remove('active');

        callback();

    });

    newCancel.addEventListener('click', () => {

        modal.classList.remove('active');

    });

};

window.jwShowSuccessToast = function (message) {
    console.log('Toast Called');
    const toast =
        document.getElementById('jw-success-toast');

    const text =
        document.getElementById('jw-success-toast-message');
    console.log(toast);
    if (!toast || !text) return;

    text.textContent = message;

    toast.classList.remove('hide');
    toast.classList.add('show');

    // Auto dismiss after 2.5 seconds
    setTimeout(() => {
        toast.classList.remove('show');
        toast.classList.add('hide');

        // Clean up hide class after animation
        setTimeout(() => {
            toast.classList.remove('hide');
        }, 100);
    }, 2500);

};

window.jwShowErrorToast = function (message) {

    const toast =
        document.getElementById('jw-error-toast');

    const text =
        document.getElementById('jw-error-toast-message');

    if (!toast || !text) return;

    text.textContent = message;

    toast.classList.remove('hide');
    toast.classList.add('show');

    setTimeout(() => {

        toast.classList.remove('show');
        toast.classList.add('hide');

    }, 2500);

};

